module.exports = { apiServer: 'https://api.uat.in-store.hk', AdminServer: 'https://admin.eventizer.hk', env: 'prod' };
